<template>
  <div class="auth-footer">
    <p>Club da Cotação® | Todos os direitos reservados</p>
    <a-button type="link" @click="$emit('privacy-click')" class="privacy-button">
      Política de privacidade
    </a-button>
  </div>
</template>

<script>
export default {
  name: "AuthFooter",
  emits: ["privacy-click"],
};
</script>

<style lang="scss" scoped>
.auth-footer {
  text-align: center;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 40px;

  p {
    color: #757575;
    font-size: 12px;
    margin-bottom: 0.1rem;
  }

  .privacy-button {
    color: #ff5722;
    font-size: 12px;
    padding: 0;
    height: auto;
  }
}
</style>
